import { render, staticRenderFns } from "./DocumentSeriesAllocationList.vue?vue&type=template&id=7f78e51c&scoped=true&"
import script from "./DocumentSeriesAllocationList.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesAllocationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78e51c",
  null
  
)

export default component.exports